export default import.meta.ROLLDOWN_FILE_URL_oGY4VIonS4rqUFJ_RZFJYg